import React from 'react';

type Props = { children: React.ReactNode };
type State = { hasError: boolean };

export class GameErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('Unable to render the game screen', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <section role="alert" aria-label="Game screen error">
          <h2>Unable to display the game</h2>
          <p>Something went wrong while displaying this game. Try again or reload the page.</p>
          <button type="button" onClick={() => this.setState({ hasError: false })}>Retry</button>
          <button type="button" onClick={() => window.location.reload()}>Reload page</button>
        </section>
      );
    }
    return this.props.children;
  }
}
